module.exports = __webpack_public_path__ + "static/media/superBrain.1691d535.webp";